<template>
  <div class="flexible-product">
    <product-banner type="flexible"></product-banner>
    <product-detail type="flexible"></product-detail>
  </div>
</template>

<script>
import ProductBanner from '@/components/product/ProductBanner'
import ProductDetail from '@/components/product/ProductDetail'

export default {
  components: {
    ProductBanner,
    ProductDetail,
  },
}
</script>
